/** Типы домена, общие для бэкенда и фронтенда. Строки — ISO 8601 в UTC, если не сказано иначе. */

export type Lang = 'ru' | 'uz';

/** ТЗ §6.2. CREATED → CONFIRMED → COMPLETED | CANCELLED | NO_SHOW. */
export type AppointmentStatus = 'CREATED' | 'CONFIRMED' | 'COMPLETED' | 'CANCELLED' | 'NO_SHOW';

/**
 * Статусы, при которых запись занимает слот и участвует в проверке пересечений (ТЗ §7).
 * Единственный источник этого списка: расхождение между кодом слотов и exclusion constraint
 * означало бы двойную бронь, которую тесты не поймают.
 */
export const ACTIVE_APPOINTMENT_STATUSES: readonly AppointmentStatus[] = ['CREATED', 'CONFIRMED'];

export type ReminderKind = 'H24' | 'H2';

export type CancelledBy = 'CLIENT' | 'BUSINESS' | 'SYSTEM';

/** Пользователь из Telegram initData (ТЗ §5). Форма поля `user` внутри initData. */
export interface TelegramUser {
  id: number;
  first_name: string;
  last_name?: string;
  username?: string;
  photo_url?: string;
  language_code?: string;
}

/** Результат успешной проверки подписи initData. */
export interface VerifiedInitData {
  user: TelegramUser;
  /** Время выпуска initData, из поля auth_date. */
  authDate: Date;
  /** Параметр start_param из deep-link — им приходит slug бизнеса при входе по QR. */
  startParam?: string;
}

/**
 * Свободный слот. `startsAt`/`endsAt` — момент времени в UTC; человекочитаемое `label`
 * («15:00») считается в часовом поясе бизнеса и потому приходит с бэкенда готовым,
 * чтобы фронт не пересчитывал пояс второй раз и не разошёлся с напоминаниями.
 */
export interface Slot {
  startsAt: string;
  endsAt: string;
  label: string;
}

/** Рабочий интервал, минуты от полуночи в часовом поясе бизнеса. */
export interface WorkingInterval {
  /** 0 = воскресенье … 6 = суббота, как в JS Date.getDay(). */
  weekday: number;
  startMin: number;
  endMin: number;
}

/** Занятый интервал: активная запись или отпуск специалиста. Абсолютное время. */
export interface BusyInterval {
  startsAt: Date;
  endsAt: Date;
}

/** Тихие часы (ТЗ §9.4): уведомления не уходят с 22:00 до 08:00 по поясу бизнеса. */
export const QUIET_HOURS_START_MIN = 22 * 60;
export const QUIET_HOURS_END_MIN = 8 * 60;
